module.exports = __webpack_public_path__ + "img/powered-by-swipe-dark.1e078321.svg";